import { useSelector } from 'react-redux';

import selectors from '@/ui/flux/selectors';
import type { Nft } from '@/ui/types';
import useWalletAccount from './use-wallet-account.js';

const EMPTY_NFTS: Nft[] = [];

export type NftData = {
  [token: string]: Nft[];
};

const useNfts = (): { loading: boolean; data: NftData | null } => {
  const walletAccount = useWalletAccount();
  const nftDataByWalletAccount = useSelector<
    unknown,
    { [walletAccount: string]: NftData }
  >(selectors.nfts.all);
  const loaded = useSelector(selectors.nfts.loaded);

  const data = nftDataByWalletAccount[walletAccount];

  // The deprecated name `polygon` causes issues with the gas estimation.
  data.polygon =
    data.polygon?.map((nft) => ({
      ...nft,
      network: 'matic',
    })) ?? EMPTY_NFTS;

  return { loading: !loaded, data };
};

export default useNfts;
